import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router";
import { ActiveLoanHeader } from "./activeLoanHeader";
import { activeLoanAdd, activeLoansGetByDealAndStatus } from "./activeLoan.store";
import { ModuleEmptyButton, LOAN_STATUSES, LOAN_SENIORITY_TYPES, DEAL_METRICS, ModuleBase, mapMetricFromList, GUEST_PERMISSIONS, GUEST_ACCESS_TYPES } from "@loanbossinc/component-library";
import { ActiveLoanBodySummary } from "./activeLoanBodySummary";
import { ActiveLoanBodyList } from "./activeLoanBodyList";
import { sortLoansBySeniority, findDistinctLendersByLoans } from "./activeLoan.filters";
import ActiveLoanHedge from "./activeLoanHedges/activeLoanHedge";
import { Collapse } from "@material-ui/core";
import {SimpleInfoModal} from "../../modals/SimpleInfoModal";

const StyledBody = styled.div`
&& {
    width: 648px;
}`;

const bodySummaryMetrics = [
    { label: "LOAN BALANCE", metricId: DEAL_METRICS.CURRENT_BALANCE },
    { label: "PREPAYMENT PENALTY", metricId: DEAL_METRICS.PREPAYMENT_PENALTY },
    { label: "ALL-IN RATE", metricId: DEAL_METRICS.ALL_IN_RATE },
    { label: "RATE TYPE", metricId: DEAL_METRICS.RATE_TYPE },
    { label: "MATURITY", metricId: DEAL_METRICS.MATURITY_DATE },
    { label: "DEBT YIELD", metricId: DEAL_METRICS.DEBT_YIELD }
];

const MAX_LENDERS_TO_SHOW = 3;

const SIMPLE_INFO_MODAL = "SIMPLE_INFO_MODAL";

class ActiveLoanLite extends Component {
    state = {
        openModal: { name: null },
        isSummaryView: true,
        bodySummaryDealMetric: [],
        sortedLoans: [],
        distinctLenders: [],
        confirmationModal:{
            title:"",
            onClose:()=>{},
            onAccept:()=>{},
            onAccept:()=>{},
            content:"",
        }
    }
    

    componentDidMount() {
        this.props.activeLoansGetByDealAndStatus({ dealId: this.props.match.params.dealId, loanStatusId: LOAN_STATUSES.CLOSED_LOAN });
        this.setNewState();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props !== prevProps) {
            this.findBodySummaryDealMetrics();
            this.setNewState();
        }
    }

    setNewState = () => {
        const { loans } = this.props;
        const sortedLoans = sortLoansBySeniority(loans);
        const distinctLenders = findDistinctLendersByLoans(loans, MAX_LENDERS_TO_SHOW);
        this.setState({ sortedLoans, distinctLenders });
    }

    findBodySummaryDealMetrics = () => {
        const { deal } = this.props;
        if (!deal || !deal.dealMetrics) return;
        const bodySummaryDealMetric = bodySummaryMetrics.reduce((accum, cur) => {
            accum.push({ label: cur.label, metricValue: mapMetricFromList(cur.metricId, deal.dealMetrics) });
            return accum;
        }, []);

        this.setState({ bodySummaryDealMetric });
    }

    addNewLoan = () => {
        const { history } = this.props;
        const newLoan = {
            loan: {
                dealId: this.props.match.params.dealId
                , loanStatusId: LOAN_STATUSES.CLOSED_LOAN
                , loanSeniorityId: LOAN_SENIORITY_TYPES.SENIOR
            },
            callback: () => history.push(`/loans/${this.props.createdLoan.id}`)
        };
        this.props.activeLoanAdd(newLoan);
    }

    addNewLoanModal = () => {
        this.openConfirmationDialog(
          "Add a Loan",
          this.closeModal,
          () => {
            this.addNewLoan();
            this.closeModal();
          },
          (<><p>Do you want to create a new loan?</p></>)
        );
      }
    
    openConfirmationDialog = (title,onClose,onAccept,content) =>{
        this.setState({confirmationModal:{title,onClose,onAccept,content}});
        this.openModal(SIMPLE_INFO_MODAL);
    }

    closeModal = () => this.setState({ openModal: { name: null } });

    openModal = (name) => this.setState({ openModal: { name } });

    isModalOpen = (modalName) => {
        const { openModal } = this.state;
        return openModal.name === modalName;
    }

    toLoanDetails = (dealId, loanId) => {
        const { history } = this.props;
        history.push(`/loans/${loanId}`)
    }

    getButtonHeaderTitle = () => {
        const { isSummaryView } = this.state;
        const { loans, guestPermission } = this.props;
        if (!loans.length && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.EDIT) return "Add a loan";
        if (loans && loans.length === 1) return "Show Details";
        if(!isSummaryView) return "Show Summary"
        return (loans && loans.length >= 1) ? "Show Loans" : "Add a loan";
    }

    handleHeaderClick = () => {
        const { isSummaryView } = this.state;
        this.setState({ isSummaryView: !isSummaryView });
    }

    renderBodyList = () => {
        const { sortedLoans, isSummaryView } = this.state;
        const { deal } = this.props;
        return (
            <Collapse in={!isSummaryView}>
                <div>
                    <ActiveLoanBodyList loans={sortedLoans} dealId={deal.id} toLoanDetails={this.toLoanDetails} />
                </div>
            </Collapse>
        )
    }

    renderBodySummary = () => {
        const { deal } = this.props;
        const { isSummaryView } = this.state;
        if (!deal) return null;
        return (
            <Collapse in={isSummaryView}>
                <StyledBody>
                    <ActiveLoanBodySummary dealMetrics={this.state.bodySummaryDealMetric} deal={this.props.deal} showPrepaymentPenalty={false} />
                </StyledBody>
            </Collapse>
        )
    }

    renderFooter = () => {
        const { deal, history, authentication, guestPermission } = this.props;
        if (!deal) return (null);
        return (
            <div style={{ borderTop: "#DADCE0 solid 1px" }}>
                <ActiveLoanHedge dealId={deal.id} history={history} authentication={authentication} guestPermission={guestPermission} />
            </div>
        )
    }

    renderHeaderAndBody = () => {
        const { authentication } = this.props;
        const { sortedLoans, distinctLenders } = this.state;

        // if they are a guest and there are no loans then return nothing
        if (authentication.isGuest && (!sortedLoans || !sortedLoans.length)) return null;

        // if they are not a guest and there are no loans then return empty loan module
        if (!sortedLoans || !sortedLoans.length) {
            return <p>No loans</p>;
        }   

        if (sortedLoans && sortedLoans.length === 1) {
            const dealId = sortedLoans[0].deal.id;
            const loanId = sortedLoans[0].id;
            return (
                <ModuleBase elevation={0}>
                    <ActiveLoanHeader
                        loans={sortedLoans}
                        distinctLenders={distinctLenders}
                        buttonTitle={this.getButtonHeaderTitle()}
                        buttonOnClick={() => { this.toLoanDetails(dealId, loanId) }}
                        addLoan={this.addNewLoanModal}
                        authentication={authentication}
                    />
                    {this.renderBodySummary()}
                    {this.renderFooter()}
                </ModuleBase>
            )
        }

        return (
            <ModuleBase elevation={0}>
                <ActiveLoanHeader
                    loans={sortedLoans}
                    distinctLenders={distinctLenders}
                    buttonTitle={this.getButtonHeaderTitle()}
                    buttonOnClick={this.handleHeaderClick}
                    addLoan={this.addNewLoanModal}
                    authentication={authentication}
                />
                {this.renderBodySummary()}
                {this.renderBodyList()}
                {this.renderFooter()}
            </ModuleBase>
        )
    }

    render() {
        const { activeLoanModuleDealLoading } = this.props;

        if (activeLoanModuleDealLoading) return null;
        return (
            <>
                {this.renderHeaderAndBody()}
                <SimpleInfoModal
                    title={this.state.confirmationModal.title}
                    isOpen={this.isModalOpen(SIMPLE_INFO_MODAL)}
                    onClose={() => this.state.confirmationModal.onClose()}
                    onAccept={() => this.state.confirmationModal.onAccept()}
                    content={this.state.confirmationModal.content}
                />
            </>
        )
    }
}

const mapStateToProps = ({ authentication, activeLoanModule }) => ({
    authentication
    , ...activeLoanModule
    , ...activeLoanModule.activeLoanModuleReducer
});

export default compose(
    withRouter
    , connect(mapStateToProps, {
        activeLoanAdd
        , activeLoansGetByDealAndStatus
    })
)(ActiveLoanLite);
